module.exports = __webpack_public_path__ + "static/media/SpenLeaf-5.3135d0a1.webp";